export const MAX_DOT_INSPECTION_IN_DAYS = 30

// TODO migrate model trailer from app
interface SlimTrailer {
  vehicleRegistration?: string
  lastDotInspection?: string
  insurancePhysicalDamage?: string
  licensePlateNumber?: string
  licensePlateState?: string
}

export const getDocumentsInitialErrors = (equipment: SlimTrailer) => {
  const {
    vehicleRegistration,
    lastDotInspection,
    licensePlateNumber,
    licensePlateState,
    insurancePhysicalDamage,
  } = equipment

  const errors: Array<string> = []

  if (!vehicleRegistration) {
    errors.push('Vehicle registration')
  }

  if (!lastDotInspection) {
    errors.push(`Clean DOT inspection from past ${MAX_DOT_INSPECTION_IN_DAYS} days`)
  }

  if (!insurancePhysicalDamage) {
    errors.push('Physical damage insurance')
  }

  if (!licensePlateNumber || !licensePlateState) {
    errors.push(`License plate`)
  }

  return errors
}
